import React, { useEffect, useState } from 'react';
import Select, { ActionMeta } from 'react-select';
import { MultiselectCustomStyles } from '$/core/styles';
import * as MicrosoftGraph from '@microsoft/microsoft-graph-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { PeopleService } from '$/services/PeopleService';
import { AppState } from '$/store';
import { toastError } from '$/store/toast/actions';
import { AnalyticsService } from '$/services';
import * as Bixby from '$/core';

interface IPeopleSearchBoxProps {
  hasError?: boolean;
  placeholder?: string;
  required?: boolean;
  title?: string;
  useSmall?: boolean;
  showMnpiUsers?: boolean;
  onChange: (ids: string[]) => void;
  profile?: Bixby.Models.Profile;
  maxMenuHeight?: number;
  dispatchPeopleSearchToastFailure: () => Promise<void>;
}

const PeopleSearchBox: React.FC<IPeopleSearchBoxProps> = props => {
  const {
    hasError,
    placeholder,
    required,
    title,
    useSmall,
    showMnpiUsers,
    onChange,
    profile,
    maxMenuHeight,
    dispatchPeopleSearchToastFailure,
  } = props;
  const [options, setOptions] = useState<{ value: string | undefined; label: string | null | undefined }[]>([]);

  useEffect(() => {
    const getUsers = async () => {
      let searchResults: MicrosoftGraph.User[] = [];
      try {
        searchResults = await PeopleService.search('', showMnpiUsers ? showMnpiUsers : false);
      } catch (e: any) {
        AnalyticsService.exception(e, {
          ...profile,
        });
        dispatchPeopleSearchToastFailure();
      }

      const results = (searchResults || []).map(r => {
        return {
          value: r.id,
          label: r.displayName,
        };
      });
      setOptions(results);
    };
    getUsers();
  }, [dispatchPeopleSearchToastFailure, profile, showMnpiUsers]);

  const handleOnChange = (value: ReadonlyArray<{ value: string }>, _actionMeta: ActionMeta<any>) => {
    onChange(
      (value || []).map(r => {
        return r.value;
      })
    );
  };

  return (
    <div className={classnames('search_block', { has_error: !!hasError, use_small: !!useSmall })}>
      <div className="search_block_title">{required ? `${title} *` : title}</div>
      <Select
        placeholder={placeholder}
        isMulti
        onChange={handleOnChange}
        options={options}
        styles={MultiselectCustomStyles}
        maxMenuHeight={maxMenuHeight}
      />
    </div>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    profile: state.profileState.profile,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchPeopleSearchToastFailure: () => dispatch(toastError('Failed to get assignee list')),
});

export default connect(mapStateToProps, mapDispatchToProps)(PeopleSearchBox);
